<template>
  <div class="container-fluid">
    <div class="row marketing">
        <div class="col-lg-4">
          <h4 class="form-head">
            New Contact
          </h4>
          <form action="" name="cform">

            <div class="form-group" >
              <label for="loca">Warehouse</label>
              <select class="form-control" id="loca" v-model="f.location.id">
                <option :value="null">PAN INDIA</option>
                <option v-for="c of locations" :key="c.id" :value="c.id">{{c.name}}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="">Warehouse Incharge Name</label>
              <input type="text" class="form-control" v-model="f.inchargeName">
            </div>
            <div class="form-group">
              <label for="">Warehouse Incharge Mobile</label>
              <input type="text" class="form-control" v-model="f.inchargeMobile">
            </div>

            <div class="form-group">
              <label for="">RDM Name</label>
              <input type="text" class="form-control" v-model="f.rdmName">
            </div>
            <div class="form-group">
              <label for="">RDM Mobile</label>
              <input type="text" class="form-control" v-model="f.rdmMobile">
            </div>

            <div class="form-group">
              <label for="tr">Transporter</label>
              <select class="form-control" id="tr" v-model="f.transporter.id">
                <option v-for="c of transporters" :key="c.id" :value="c.id">{{c.name}}</option>
              </select>

            </div>

            <table class="table-sm table">
              <thead class="thread-light">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>
                  <button class="btn btn-info btn-sm" @click.stop="f.trContacts.push({'name': '', 'email': '', 'mobile': ''})">
                    <i class="fa fa-plus"></i>
                  </button>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ctr, idx) in f.trContacts" :key="idx">
                <td>
                  <input type="text" class="form-control form-control-sm" v-model="ctr.name">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm" v-model="ctr.email">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm" v-model="ctr.mobile">
                </td>
                <td>
                  <a @click="f.trContacts.splice(idx,1)" class="btn btn-danger btn-sm">
                    <i class="fa fa-times"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>

            <button type="button" v-on:click="saveContact()" class="btn btn-primary">
              Save
            </button>

          </form>
        </div>
        <div class="col-lg-8">
          <h4 class="form-head">
            Existing Contacts
          </h4>
          <table class="table table-borderless">
            <thead class="thead-dark">
            <tr>
              <th>Warehouse</th>
              <th>InCharge</th>
              <th>RDM</th>
              <th>Transporter Contact</th>
              <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="u of contacts" :key="u.id">
              <td>
                <span v-if="u.location && u.location.id">{{u.location.name}}</span>
                <span v-if="!u.location">PAN INDIA</span>
              </td>
              <td>{{u.inchargeName}} <br />{{u.inchargeMobile}}</td>
              <td>{{u.rdmName}} <br />{{u.rdmMobile}}</td>
              <td>
                <ul class="list-group">
                  <li class="list-group-item list-group-item-dark">

                    <div class="d-flex justify-content-between">
                      <div><span v-if="u.transporter && u.transporter.name">{{u.transporter.name}}</span></div>
                      <a @click="editTRContact({contactDetails: {id: u.id}})" class="btn btn-sm btn-outline-light"><i class="fa fa-plus"></i></a>
                    </div>

                  </li>
                  <li class="list-group-item" v-for="c in u.trContacts" :key="c.id">
                    <div class="d-flex flex-column justify-content-between">
                      <div>
                        <div class="d-flex justify-content-between">
                          <div>{{c.name}}</div>
                        </div>
                      </div>
                      <div>{{c.mobile}}</div>
                      <div>
                        <div class="d-flex justify-content-between">
                          <div>{{c.email}}</div>
                          <a @click="editTRContact(c)" class="btn btn-sm btn-outline-light"><i class="fa fa-pencil"></i></a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </td>
              <td>
                <div class="btn-group">

                  <button class="btn btn-outline-primary btn-sm" @click="editContact(u)">
                    <i class="fa fa-pencil"></i>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      <b-modal id="trContactEdit" ref="trContactEdit" title="Edit Contact"
               @ok="saveTRContact()"
               size="lg" centered lazy>
        <b-form>
          <b-form-group label="Name">
            <b-form-input v-model="trC.name" type="text"></b-form-input>
          </b-form-group>
          <b-form-group label="EMail">
            <b-form-input v-model="trC.email" type="text"></b-form-input>
          </b-form-group>
          <b-form-group label="Phone">
            <b-form-input v-model="trC.mobile" type="text"></b-form-input>
          </b-form-group>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

let contactUrl = `/app/contact`
let trContactUrl = `/app/contact/transporter`
let locationsUrl = `/app/location`
let apiUrlTransporter = `/app/party?type=TRANSPORTER`

export default {
  name: 'UserPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }

      this.loadDetails()
    })
  },
  data () {
    return {
      f: {
        id: null,
        location: {
          id: null
        },
        transporter: {
          id: null
        },
        inchargeName: '',
        inchargeMobile: '',
        rdmName: '',
        rdmMobile: '',
        trContacts: [
          {name: '', email: '', mobile: ''}
        ]
      },
      locations: [],
      transporters: [],
      contacts: [],
      trC: {}
    }
  },
  computed: {},
  methods: {
    editContact: function (c) {
      let cClone = Object.assign({}, c)
      if (!c['transporter']) {
        console.log('transporter not found')
        cClone['transporter'] = {'id': null}
      }
      if (!c['location']) {
        console.log('location not found')
        cClone['location'] = {'id': null}
      }
      console.log('edit', cClone)
      this.f = Object.assign({}, cClone)
    },
    saveContact: function () {
      console.log('Saving', this.f)
      let f = Object.assign({}, this.f)
      if (f.location.id == null) {
        delete f['location']
      }
      let fPost = Object.assign({}, f)
      delete fPost['trContacts']

      axios.post(contactUrl, fPost)
        .then(response => {
          let posts = f.trContacts.map(trC => {
            let trCPost = Object.assign({}, trC)
            trCPost['contactDetails'] = {id: response.data.id}
            axios.post(trContactUrl, trCPost)
          })

          axios.all(posts)
            .then(axios.spread(() => {
              this.f = {
                id: null,
                location: {
                  id: null
                },
                transporter: {
                  id: null
                },
                inchargeName: '',
                inchargeMobile: '',
                rdmName: '',
                rdmMobile: '',
                trContacts: [
                  {name: '', email: '', mobile: ''}
                ]
              }
              this.loadDetails()
            }))
        }, error => {
          console.error('Error in Saving User', error)
        })
    },
    editTRContact: function (tr) {
      this.trC = Object.assign({}, tr)
      this.$refs.trContactEdit.show()
    },
    saveTRContact: function () {
      axios.post(trContactUrl, this.trC)
        .then(resp => {
          this.loadDetails()
          this.$refs.trContactEdit.hide()
        }, err => {
          console.error('error in saving trContact', err)
        })
    },
    loadDetails: function () {
      axios.all([
        axios.get(apiUrlTransporter),
        axios.get(locationsUrl),
        axios.get(contactUrl)
      ]).then(axios.spread((transporters, locations, contacts) => {
        this.transporters = transporters.data
        this.locations = locations.data
        this.contacts = contacts.data
      }))
    },
    saveTr: tr => {
      axios.post(trContactUrl, tr)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/ContactPage.vue